import actionTypes from '@atom/actions/actionTypes';

export const updateWorkOrdersInput = data => ({
  type: actionTypes.UPDATE_WORK_ORDERS_INPUT,
  data,
});
